import Column from "@amzn/meridian/esm/components/column";
import Icon from "@amzn/meridian/esm/components/icon";
import Text from "@amzn/meridian/esm/components/text";
import errorTokens from "@amzn/meridian-tokens/base/icon/error";

// In-conversation agent-chat error rendering. Shows the in-stream backend `message`
// split into a bold heading line + body line (on the first sentence), falling back
// to hardcoded copy when no message was received (network / non-JSON gateway error).

const FALLBACK = "We hit a snag on what's happened so far. You can use other features or refresh the app.";

// Split on the first sentence: "<heading>. <body>" -> [heading, body]. Copy without
// a sentence break renders as a single heading line.
const splitMessage = (message) => {
  const match = message.match(/^(.*?[.!?])\s+(.*)$/s);
  return match ? [match[1], match[2]] : [message, ""];
};

const AgentErrorMessage = ({ errorMessage }) => {
  const [heading, body] = splitMessage(errorMessage || FALLBACK);
  return (
    <Column spacing="300" spacingInset="300 none">
      <Icon tokens={errorTokens} color="error" />
      <Text type="b200">
        <strong>{heading}</strong>
      </Text>
      {body && <Text type="b100">{body}</Text>}
    </Column>
  );
};

export default AgentErrorMessage;
